import { fetchV1Base } from 'helpers/fetch.js';
import { toQueryString } from 'helpers/api.js';

export default {
  log(event) {
    return fetchV1Base.post(`/user_analytics/events`, event);
  },
  getEvents(filters) {
    return fetchV1Base.get(`/user_analytics/events?${toQueryString(filters)}`);
  },
};
